const _temp0 = require("url:./dice-1.png");
const _temp1 = require("url:./dice-2.png");
const _temp2 = require("url:./dice-3.png");
const _temp3 = require("url:./dice-4.png");
const _temp4 = require("url:./dice-5.png");
const _temp5 = require("url:./dice-6.png");
module.exports = {
  "dice-1": _temp0,
  "dice-2": _temp1,
  "dice-3": _temp2,
  "dice-4": _temp3,
  "dice-5": _temp4,
  "dice-6": _temp5
}